// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

export default function generateErrorReportYaml(createdFiles, failedFiles) {
  let yaml = '# Bulk Upload Report\n';
  yaml += `# Generated: ${new Date().toISOString()}\n`;
  yaml += `# Total Success: ${createdFiles.length}\n`;
  yaml += `# Total Failures: ${failedFiles.length}\n\n`;

  if (createdFiles.length > 0) {
    yaml += '# Successfully Created Files\n';
    yaml += 'success:\n';
    createdFiles.forEach(file => {
      yaml += `  ${file.name}:\n`;
      yaml += `    id: "${file.id}"\n`;
      yaml += `    writeKey: "${file.writeKey}"\n`;
      yaml += `    status: "created"\n`;
      yaml += '\n';
    });
    yaml += '\n';
  }

  if (failedFiles.length > 0) {
    yaml += '# Failed Files\n';
    yaml += 'failures:\n';
    failedFiles.forEach(file => {
      yaml += `  ${file.name}:\n`;
      yaml += `    errors:\n`;
      file.errors.forEach(errorObj => {
        yaml += `      - error: "${errorObj.error}"\n`;
        yaml += `        reason: "${errorObj.reason}"\n`;
      });
      yaml += '\n';
    });
  }

  return yaml;
}
